import { create } from 'zustand'

type Store = {
  videoUrl: string
}

export const store = create<Store>(() => ({
  videoUrl: null
}))
